module.exports = __webpack_public_path__ + "static/img/bg-introduce.4f5239cd.jpg";